import React from "react";
import { Artist } from "../../models";

interface ArtistImageProps {
    artist: Artist;
}

export const ArtistImage = ({ artist }: ArtistImageProps) => (
    <div className="artist-image">
        {artist.getImageUrl() != null && <img alt={artist.getName()} src={artist.getImageUrl()} />}
    </div>
);
